import { render, staticRenderFns } from "./comTerm15.vue?vue&type=template&id=7f6dc6a4&scoped=true&"
import script from "./comTerm15.vue?vue&type=script&lang=js&"
export * from "./comTerm15.vue?vue&type=script&lang=js&"
import style0 from "./comTerm15.vue?vue&type=style&index=0&id=7f6dc6a4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f6dc6a4",
  null
  
)

export default component.exports